export default __webpack_public_path__ + "assets/icons/all-function.bc791e10.svg";